import { RootState } from "@/app/store";
import { ResourceTypes } from "@/app/types/roles";
import { Button } from "@/components/ui/Button";
import { extractLinks } from "@/utils/Helper";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useMemo } from "react";
import useDocumentTitle from "@/hooks/UseDocumentTitle";

const WelcomePage = () => {
    useDocumentTitle("Dashboard");
    const { userInfo } = useSelector((state: RootState) => state.auth);
    const sidePanel = localStorage.getItem("sidePanel");
    let decodedSidepanel: ResourceTypes[] = [];

    try {
      const decoded = atob(sidePanel || "");
      decodedSidepanel = JSON.parse(decoded);
    } catch (err) {
      console.error("Error decoding sidePanel from localStorage", err);
    }


    const singleResourceList = useMemo(() =>
        decodedSidepanel.filter((resource: ResourceTypes) =>
            resource?.children && resource?.children.length === 0 && resource.code !== 'dashboard' || resource.name==="Tickets"
        ), [decodedSidepanel]
    );

    const multiResourceList = useMemo(() =>
        decodedSidepanel.filter((resource: ResourceTypes) =>
            resource?.children && resource?.children.length > 0 && resource.name !=="Tickets"
        ), [decodedSidepanel]
    );
    const orgName=userInfo?.org_name || "QMS"

    return (
      <>
        <h1 className="pt-5 px-9 text-xl font-semibold tracking-tighter text-black text-left">
          {/* Welcome to <span className="text-primary">QMS</span> */}
          Welcome to
          <span className="pl-2 text-primary">{orgName}</span>
        </h1>
        <div className="flex flex-col items-center space-y-4 min-h-screen py-5 not-italic text-gray-900 text-sm md:text-base dark:text-gray-100">
          <div className="container flex flex-col items-center space-y-2 text-center">
            <div className="grid grid-cols-1 slg:grid-cols-2 gap-2 w-full">
              <div className="bg-white rounded-md p-2 col-span-1">
                <div className="flex justify-start items-center px-2">
                  <i className={`fa-regular fa-window-maximize text-black`}></i>
                  <p className="text-black text-left font-medium p-2">
                    Quick Access
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {singleResourceList.filter((resource: { link: string; }) => resource.link !== '/').map((resource: ResourceTypes) => (
                    <Link key={resource.id} to={resource.link}>
                      <Button
                        variant={"secondary"}
                        className="w-full text-black hover:bg-lightprimary hover:border-lightprimary flex flex-row justify-start gap-4 gap-y-1 items-start h-16 "
                      >
                        <i
                          className={`${resource.icon} text-black  text-lg`}
                        ></i>
                        <span className=" text-sm font-medium">
                          {resource.name}
                        </span>
                      </Button>
                    </Link>
                  ))}
                </div>
              </div>

              {multiResourceList.map((resource: ResourceTypes) => (
                <div
                  key={resource.id}
                  className="bg-white rounded-md p-2 col-span-1"
                >
                  <div className="flex justify-start items-center px-2">
                    <i className={`${resource.icon} text-black`}></i>
                    <p className="text-black text-left font-medium p-2">
                      {resource.name}
                    </p>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    {resource.children?.map((child: ResourceTypes) => (
                      <Link key={child.id} to={child.link}>
                        <Button
                          variant={"secondary"}
                          className="w-full text-black flex-row hover:bg-lightprimary hover:border-lightprimary  flex justify-start gap-4 gap-y-1 items-start h-fit"
                        >
                          <i
                            className={`${child.icon} text-black  text-lg`}
                          ></i>
                          <span className="text-left text-sm font-medium">
                            {child.name}
                          </span>
                        </Button>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
};

export default WelcomePage;